export const mapRegistrationProfileToForm = (profileCache) => {
  if (!profileCache) {
    return {};
  }
  return {
    firstName: profileCache.firstName || '',
    lastName: profileCache.lastName || '',
    phone: profileCache.phone || '',
  };
};
